import updateDisplayNumber from '../utils/update-display-number.js';
export default function processResults(data, settings) {
	//Insert new posts into the page
	const insertParent = settings.insert.parentNode;
	insertParent.insertAdjacentHTML('beforeend', data);
	// Update the load more display number;
	updateDisplayNumber(settings);
}
